import * as React from 'react'
import { Field } from 'react-final-form'
import { InputText } from '../../atoms/input-text/index'

interface Props {
  name: string
  type: string
  value: string
}

export default (props: Props) => (
  <Field name={props.name}>
    {({ input, meta }) => (
      <InputText {...input} type={props.type} value={props.value} />
    )}
  </Field>
)



// WEBPACK FOOTER //
// ./src/components/molecules/text-field/hidden-field.tsx